var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"card-bg rounded-20 pb-4",attrs:{"flat":""}},[_c('v-toolbar',{staticClass:"transparent",attrs:{"flat":"","dense":""}},[_c('v-toolbar-title',{staticClass:"title-font"},[_vm._v(" QUOTA OVERVIEW ")])],1),_c('v-card',{staticClass:"mx-4 pb-4 rounded-10",attrs:{"flat":""}},[_c('QuotaOverview')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }